import styled from "styled-components";
import { useState } from "react";
import { NativeNumberKeyPad } from "./NativeNumberKeyPad";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { useTranslation } from "@coworker/locales";
import { RegexOptions } from "./shared/RegexOptions";

const Container = styled("div")`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--white);
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
`;
const OverflowBackground = styled("div")`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--grey800);
  opacity: 0.8;
`;

const InputWrapper = styled("div")`
  margin: 0px 30px 30px 30px;
  gap: 15px;
  display: flex;
  flex-direction: column;
`;

const BreakLine = styled("hr")`
  width: 100%;
  border: 1px solid var(--grey150);
  margin: 0px 0px 20px 0px;
`;

export interface AffectedQuantityProps {
  value: string;
  bigTitle: string;
  onSubmit: (affectedQuantity: number) => void;
  onChange: (response: object) => void;
  onClose: () => void;
}

const AffectedQuantity = ({
  value,
  onSubmit,
  bigTitle,
  onClose,
}: AffectedQuantityProps) => {
  const [affectedQuantityValue, setaffectedQuantityValue] = useState<string>(
    value || "1"
  );
  const { t } = useTranslation();

  const parsedAffectedQuantity = Number(affectedQuantityValue);

  return (
    <>
      <OverflowBackground
        onClick={() => {
          onClose?.();
        }}
      />
      <Container>
        <FixaModalHeader title={bigTitle} closeBtnClick={() => onClose?.()} />
        <BreakLine />
        <InputWrapper>
          <NativeNumberKeyPad
            disabled={false}
            initialValue={""}
            inputMode="numeric"
            keypadType="number"
            onUpdate={(value) => setaffectedQuantityValue(value)}
            onComplete={() => {
              onSubmit(parsedAffectedQuantity);
            }}
            maxLength={3}
            suffixLabel={t("piecesUnit")}
            regexOptions={RegexOptions.ONLYNUMBERS}
            autoFocus={true}
          />

          <FixaButton
            text={t("submitString")}
            onClick={() => {
              onSubmit(parsedAffectedQuantity);
            }}
            type="primary"
            fluid
          ></FixaButton>
        </InputWrapper>
      </Container>
    </>
  );
};

export default AffectedQuantity;
